import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Star, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Stays.css';

const Stays = () => {
  const navigate = useNavigate();
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL_DESTINATIONS = 'https://travels-works.onrender.com/api/destinations';

  useEffect(() => {
    // Simulated fetch for luxury rooms
    setLoading(true);
    setTimeout(() => {
      setDestinations([
        { _id: 'r1', name: 'Royal Heritage Suite', state: 'Rajasthan', rating: 4.9, img: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'r2', name: 'Oceanview Villa', state: 'Goa', rating: 4.8, img: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'r3', name: 'Himalayan Retreat', state: 'Himachal', rating: 4.7, img: 'https://images.unsplash.com/photo-1566665797739-1674de7a421a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'r4', name: 'City Skyline Loft', state: 'Mumbai', rating: 4.9, img: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'r5', name: 'Backwaters Houseboat', state: 'Kerala', rating: 4.8, img: 'https://images.unsplash.com/photo-1542314831-c6a4d1409395?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'r6', name: 'Palace View Room', state: 'Udaipur', rating: 5.0, img: 'https://images.unsplash.com/photo-1578683010236-d716f9a3f461?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
      ]);
      setLoading(false);
    }, 600);
  }, []);

  return (
    <div className="stays-page">
      <header className="stays-header">
        <button className="back-btn-pill-st" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> <span>Back</span>
        </button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="header-content-st">
          <h1>Luxury <span className="highlight-text-st">Rooms</span></h1>
          <p>Find the perfect accommodation for your next journey.</p>
        </motion.div>
      </header>

      <section className="stays-grid-container">
        {loading ? (
          <div className="loading-state-st">Loading premium stays...</div>
        ) : (
          <div className="stays-grid">
            <AnimatePresence>
              {destinations.map((item, index) => (
                <motion.div 
                  key={item._id || index} 
                  className="stay-card-st"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                >
                  <img src={item.img} alt={item.name} />
                  <div className="stay-overlay-st">
                    <span className="location-tag-st"><MapPin size={14}/> {item.country || item.state}</span>
                    <h3>{item.name}</h3>
                    <div className="rating-display-st">
                      <Star size={14} className="star-icon-st" fill="#fcd34d" color="#fcd34d" /> {item.rating}
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        )}
      </section>
    </div>
  );
};

export default Stays;
